import { Component } from '@angular/core';
import { ResultListDialogComponent } from './result-list-dialog/result-list-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { UserpilotReloader } from '../../helper/userpilot-reloader.component';

@Component({
  selector: 'app-history-picker',
  templateUrl: './history-picker.component.html',
  styleUrls: ['./history-picker.component.scss']
})
export class HistoryPickerComponent extends UserpilotReloader {
  constructor(
    private dialog: MatDialog
  ) {
    super();
  }

  onHistoryClick() {
    this.dialog.open(ResultListDialogComponent, { data: {} });
  }
}
